import { Group, SegmentedControl } from "@mantine/core";
import { CreateProjectButton } from "./CreateProjectButton/CreateProjectButton";

interface SiteStatusControlsProps {
  showDemoProjects: boolean;
  showDemoProjectsToggle: boolean;
  onToggleDemoProjects: (show: boolean) => void;
  onCreateProject: (projectId: string) => void;
}

function SiteStatusControls({
  showDemoProjects,
  showDemoProjectsToggle,
  onToggleDemoProjects,
  onCreateProject
}: SiteStatusControlsProps) {
  return (
    <Group className="SiteStatusControls" gap="md">
      {showDemoProjectsToggle && (
        <SegmentedControl
          color="primary"
          data={[
            { label: "Kunden Projekte", value: "customer" },
            { label: "Demo Projekte", value: "demo" }
          ]}
          value={showDemoProjects ? "demo" : "customer"}
          onChange={(value) => onToggleDemoProjects(value === "demo")}
        />
      )}
      <CreateProjectButton onCreateProject={onCreateProject} />
    </Group>
  );
}

export { SiteStatusControls };
